import {
	LogoutCommandHandlerFactory
} from "./../../../../utils/authorization/authorizationFactory";
import { Component } from "vue-property-decorator";
import Vue from "vue";
import { AuthVerified } from "../../../../models/generic/auth-transfer";
import { LabelSetting } from "../../../../i18n/locale-helper";
import { storeModules } from "../../../../store";
import { Getter , namespace, Action} from "../../../../../node_modules/vuex-class";
import UserMenuComponent from "../user-menu";
import i18n from "../../../../i18n";
import QrCodeComponent from "../../../../components/qr-code";
// import UserConfigurationComponent from "../../../../components/user-configuration";
import AboutComponent from '../../../../components/help/AboutComponent.vue';
import LogmeinComponent from "../../../../components/logmein";
import { ROUTER } from "../../../../common/constants";
import EventTracker from "../../../../utils/event-tracker";
import { TRACKING_EVENTS } from "../../../../common/tracking-event.constants";

const CommonGetter = namespace(storeModules.Common, Getter);
const UserAction = namespace(storeModules.User, Action);
const UserGetter = namespace(storeModules.User, Getter);
@Component({
	template: require("./template.html"),
	components: {
		UserMenuComponent,
		QrCodeComponent,
		LogmeinComponent
	}
})
class ProfileComponent extends Vue {
	public userMenuComponent: any = null;
	public qrCodeComponent: QrCodeComponent = null;
	public aboutComponent: any = null;
	logmeinComponent: LogmeinComponent = null;
	//#region Store getter declaration
    @CommonGetter userSession: AuthVerified;
    
    @UserGetter userInfo: any;
    @UserAction getUserInfo: (id: any) => Promise<any>;
	
	/** LOCALIZATION */
	statusLocalizationSetting = LabelSetting.Status;
    lblSetting = LabelSetting.Global;
    
    get avatar() {
        if (this.userInfo) {
            return this.userInfo.AvatarUrl ? {
                background: `url(${this.userInfo.TempAvatar})`,
            } : null;
        }
        return null;
    }


	get userName(): string {
		if (this.userSession == null || this.userSession.UserInfo == null)
			return "";
		return this.userSession.UserInfo.ShortName || "";
	}

	get name(): string {
		if (this.userSession == null || this.userSession.UserInfo == null)
			return "";
		return this.userSession.UserInfo.Name || "";
	}
	/**
	 *
	 */
	constructor() {
		super();
	}

	handleHelp() {
		this.$closeTippy();
		if(!this.aboutComponent) {
			this.initAboutComponent();
		}
		this.aboutComponent.visible = true;
        this.aboutComponent.userInfo = this.userSession.UserInfo;
        this.trackEvent('ShowAppInfo');
	}
	
	handleUserConfiguration() {
		this.$closeTippy();
		// if (!this.userConfigurationComponent) {
		// 	this.initUserConfigurationComponent();
		// }
        // this.userConfigurationComponent.visible = true;
        this.$router.push({
            name: ROUTER.MY_ACCOUNT
        })
        this.trackEvent('UserConfiguration');
    }
    
    handleAppConfiguration() {
        this.$closeTippy();
        // if (!this.userConfigurationComponent) {
        // 	this.initUserConfigurationComponent();
        // }
        // this.userConfigurationComponent.visible = true;
        this.$router.push({
            name: ROUTER.CONFIGURATION
        })
    }
	handleQRCode() {
		this.$closeTippy();
		if (!this.qrCodeComponent) {
			this.initQrCodeComponent();
		}
		this.qrCodeComponent.visible = true;
        this.qrCodeComponent.userInfo = this.userSession.UserInfo;
        this.trackEvent('QRCode');
	}
	
	handleLogout() {
		let message = this.$t(LabelSetting.Global.confirmLeave).toString();
		if(message.indexOf("|") > -1){
			let  messageArrays = message.split("|");
			message = messageArrays[0];
		}
		this.$confirm(
			message,
			this.$t(this.statusLocalizationSetting.warning).toString(),
			{
				confirmButtonText: this.$t(LabelSetting.Action.ok).toString(),
				cancelButtonText: this.$t(LabelSetting.Action.cancel).toString(),
				type: "warning",
				confirmButtonClass: "el-button--warning",
			}
		).then(() => {
			const logoutCommand = new LogoutCommandHandlerFactory();
			return logoutCommand
				.Logout()
        });
        this.trackEvent('Logout');
	}
	initQrCodeComponent() {
		this.qrCodeComponent = new QrCodeComponent({
			i18n: this.$i18n,
			methods: {
			
			}
		}).$mount();
	}
	initUserMenuComponent() {
		this.userMenuComponent = (new UserMenuComponent({
			i18n: i18n,
			data() {
				return {
					lblSetting: LabelSetting.Global
				}
			},
			methods: {
				handleLogout: () => this.handleLogout(),
                handleUserConfiguration: () => this.handleUserConfiguration(),
                handleAppConfiguration: () => this.handleAppConfiguration(),
				handleQRCode: () => this.handleQRCode(),
				handleHelp: () => this.handleHelp(),
				handleLogmein: () => this.handleLogmein()
			}
		})).$mount();
	}

	private handleLogmein() {
		this.$closeTippy();
		if (!this.logmeinComponent) {
			const userSession = this.userSession;
			this.logmeinComponent = (new LogmeinComponent({
				i18n: i18n,
				data() {
					return {
						lblSetting: LabelSetting.Global,
						userSession: userSession
					}
				},
			})).$mount();
		}
        this.logmeinComponent.visible = true;
        this.trackEvent('OpenLogmein');
    }

	initAboutComponent() {
		this.aboutComponent =  (new AboutComponent({
			i18n: i18n,
			data() {
				return {
					lblSetting: LabelSetting.Global
				}
			},
		})).$mount();
    }
    
    private trackEvent(action: string) {
        EventTracker.logEvent({
            FormName: TRACKING_EVENTS.PAGES.GLOBAL,
            Action: TRACKING_EVENTS.EVENTS.SELECT_USER_SETTING,
            FormId: 0,
            Comment: {action: action}
        })
    }

	async mounted() {
		setTimeout(() => {
			this.initUserMenuComponent();
			this.initQrCodeComponent();
        }, 1000);
        this.getUserInfo(this.userSession.UserInfo.Id).then(() => {
        }).catch(error => {
            this.$message({
                message: error.data.msg,
                type: "error"
            });
        })
	}
}

export default ProfileComponent;
